<template>
  <zm-drawer
    ref="zmDrawer"
    :visible="visible"
    :title="title"
    :footer="footer"
    :okText="okText"
    :width="'75%'"
    :placement="placement"
    @cancel="cancel"
    @ok="submitForm"
    class="modal"
  >
    <div slot="drawerBody">
      <a-form-model
        ref="dataForm"
        :model="dataForm"
        v-bind="formItemLayoutWithOutLabel"
      >
        <a-row>
          <a-col :span="8">
            <span style="color: #08409F;font-size: 14px;font-weight: bold;margin-right: 13px"> {{ dropdownLinkName }}</span>
<!--            <a-dropdown placement="bottomCenter">-->
<!--              <a class="ant-dropdown-link">-->
<!--                <img src="@/assets/icon_switch.png" alt="" style="margin-bottom: 2px;">-->
<!--              </a>-->
<!--              <a-menu slot="overlay">-->
<!--                <a-menu-item v-for="item in derivationModeList">-->
<!--                  <a href="javascript:;" @click="changeExportType(item)">{{ item.label }}</a>-->
<!--                </a-menu-item>-->
<!--              </a-menu>-->
<!--            </a-dropdown>-->
          </a-col>
        </a-row>
        <div v-if="!customFieldShow" style="margin-top: 10px;">
          <module-box></module-box>
        </div>
        <div v-if="customFieldShow">
          <a-row
            class="marginTop_10"
            :style="{borderBottom: (fixedModule.length-1 !== index) ? '1px dashed #d9d9d9' : 'none'}"
            v-for="(domain, index) in fixedModule"
            :key="domain.key">
            <a-col :span="8">
              <a-form-model-item
                class="marginBtm_0"
                v-bind="formItemLayout"
                label="分类模块"
              >
                <span>{{ domain.icon }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="margin-bottom: 10px;">
              <div class="checkBoxGroupDiv">
                <a-checkbox class="allCheckBox checkBoxGroupTitle" :indeterminate="domain.indeterminate" :checked="domain.checkAll" @change="fixedAllChange(index, $event)">
                  全选
                </a-checkbox>
                <a-checkbox-group class="checkBoxGroup" v-model="domain.chickList" :options="domain.items" @change="fixedOnChange(index, $event)"/>
              </div>
            </a-col>
          </a-row>
<!--          <a-row-->
<!--            class="marginTop_10"-->
<!--            :style="{borderBottom: (dataForm.moduleList.length-1 !== index) ? '1px dashed #d9d9d9' : 'none'}"-->
<!--            v-for="(domain, index) in dataForm.moduleList"-->
<!--            :key="domain.key">-->
<!--            <a-col :span="8">-->
<!--              <a-form-model-item-->
<!--                class="marginBtm_0"-->
<!--                v-bind="formItemLayout"-->
<!--                label="字段分类"-->
<!--                :prop="'moduleList.' + index + '.value'"-->
<!--                :rules="{-->
<!--                  required: true,-->
<!--                  message: '请选择字段分类'-->
<!--                }"-->
<!--              >-->
<!--                <a-select-->
<!--                  dropdownClassName="select"-->
<!--                  placeholder="请选择字段分类"-->
<!--                  v-model="domain.value"-->
<!--                  style="width: 100%"-->
<!--                >-->
<!--                  <a-select-option v-for="(item, index) in classificationField" :key="index" :value="item.icon" :data="item" :disabled="item.disabled">-->
<!--                    {{ item.icon }}-->
<!--                  </a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="8">-->
<!--              <a-form-model-item-->
<!--                class="marginBtm_0"-->
<!--                v-bind="formItemLayout"-->
<!--                label="分类模块"-->
<!--                :prop="'moduleList.' + index + '.value'"-->
<!--                :rules="{-->
<!--                  required: true,-->
<!--                  message: '请选择分类模块'-->
<!--                }"-->
<!--              >-->
<!--                <a-select-->
<!--                  dropdownClassName="select"-->
<!--                  @change="(value, option) => changeType(value, option, index)"-->
<!--                  placeholder="请选择分类模块"-->
<!--                  v-model="domain.value"-->
<!--                  style="width: 100%"-->
<!--                >-->
<!--                  <a-select-option v-for="(item, index) in classificationField" :key="index" :value="item.icon" :data="item" :disabled="item.disabled">-->
<!--                    {{ item.icon }}-->
<!--                  </a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="1" class="closeIcon">-->
<!--              <img class="moduleColseImg" src="@/assets/icon_del.png" alt="" v-if="dataForm.moduleList.length > 1" :disabled="dataForm.moduleList.length === 1" @click="removeModule(domain)">-->
<!--            </a-col>-->
<!--            <a-col :span="24" style="margin-bottom: 10px;">-->
<!--              <div class="checkBoxGroupDiv">-->
<!--                <a-checkbox class="allCheckBox checkBoxGroupTitle" v-if="checkedList[index].plainOptions" :indeterminate="checkedList[index].indeterminate" :checked="checkedList[index].checkAll" @change="allChange(index, $event)">-->
<!--                  全选-->
<!--                </a-checkbox>-->
<!--                <a-checkbox-group class="checkBoxGroup" v-model="checkedList[index].checkedList" :options="checkedList[index].plainOptions" @change="onChange(index, $event)"/>-->
<!--              </div>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--          <a-row>-->
<!--            <a-col :md="24">-->
<!--              <a-button type="dashed" style="width:100%" @click="addModule" block class="add-btn">-->
<!--                <a-icon type="plus" />添加-->
<!--              </a-button>-->
<!--            </a-col>-->
<!--          </a-row>-->
        </div>
      </a-form-model>
    </div>
  </zm-drawer>
</template>

<script>
import exportWrap from './exportWrap.json'
import { getEquipmentExport } from '@/api/equipmentLedger'
import ModuleBox from '@/views/assetLedger/modules/moduleBox'
export default {
  components: { ModuleBox },
  data () {
    return {
      // 抽屉是否显示
      visible: false,
      // 抽屉标题
      title: '',
      footer: true,
      okText: '导出',
      placement: 'right',
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      formItemLayoutWithOutLabel: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      btnLoading: false,
      dataForm: {
        exportType: '2',
        moduleList: []
      },
      dropdownLinkName: '自定义导出',
      // 导出方式列表下拉
      derivationModeList: [
        {
          value: '1',
          label: '模板导出'
        },
        {
          value: '2',
          label: '自定义导出'
        }
      ],
      // 自定义字段显示
      customFieldShow: true,
      // 分类字段
      classificationField: exportWrap,
      // 固定模块
      fixedModule: exportWrap,
      checkedList: [],
      searchModel: {}
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.searchModel = model
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
    },
    // 导出
    submitForm () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.$refs.zmDrawer.handleOkLoading(true)
          const params = {
            exportType: this.dataForm.exportType,
            ...this.searchModel
          }
          if (this.dataForm.exportType === '2') {
            params.colKeys = []
            params.headNames = []
            this.fixedModule.map(item => {
              item.chickList.forEach(item2 => {
                const arr = item2.split(';')
                params.colKeys.push(arr[1])
                params.headNames.push(arr[0])
              })
            })
          }
          getEquipmentExport(params).then(res => {
            var blob = new Blob([res])
            var downloadElement = document.createElement('a')
            var href = window.URL.createObjectURL(blob)
            downloadElement.href = href
            downloadElement.download = '设备列表.xls'
            document.body.appendChild(downloadElement)
            downloadElement.click()
            document.body.removeChild(downloadElement)
            window.URL.revokeObjectURL(href)
            this.$refs.zmDrawer.handleOkLoading(false)
            this.cancel()
          })
            .catch(err => {
              this.$refs.zmDrawer.handleOkLoading(false)
            })
        } else {
          return false
        }
      })
    },
    // 改变导出方式
    changeExportType (item) {
      this.dropdownLinkName = item.label
      this.dataForm.exportType = item.value
      if (item.value === '1') {
        this.customFieldShow = false
      } else {
        this.customFieldShow = true
        // if (this.dataForm.moduleList.length < 1) {
        //   this.addModule()
        // }
      }
    },
    // 选择分类模块
    changeType (value, option, index) {
      this.checkedList[index].plainOptions = option.data.attrs.data.items
      option.data.attrs.data.disabled = true
    },
    // 单个字段选择
    onChange (index, checkedList) {
      this.checkedList[index].indeterminate = !!checkedList.length && checkedList.length < this.checkedList[index].plainOptions.length
      this.checkedList[index].checkAll = checkedList.length === this.checkedList[index].plainOptions.length
      this.$forceUpdate()
    },
    // 字段全选
    allChange (index, e) {
      const plainOptions = []
      this.checkedList[index].plainOptions.forEach(item => {
        plainOptions.push(item.value)
      })
      this.checkedList[index].checkedList = e.target.checked ? plainOptions : []
      this.checkedList[index].checkAll = e.target.checked
      this.checkedList[index].indeterminate = false
      this.$forceUpdate()
    },
    // 固定模块字段选中
    fixedOnChange(index, checkedList) {
      this.fixedModule[index].indeterminate = !!checkedList.length && checkedList.length < this.fixedModule[index].items.length
      this.fixedModule[index].checkAll = checkedList.length === this.fixedModule[index].items.length
      this.$forceUpdate()
    },
    // 固定模块字段全选
    fixedAllChange(index, e) {
      const plainOptions = []
      this.fixedModule[index].items.forEach(item => {
        plainOptions.push(item.value)
      })
      this.fixedModule[index].chickList = e.target.checked ? plainOptions : []
      this.fixedModule[index].checkAll = e.target.checked
      this.fixedModule[index].indeterminate = false
      this.$forceUpdate()
    },
    // 删除模块
    removeModule (item) {
      const index = this.dataForm.moduleList.indexOf(item)
      const selectIndex = this.classificationField.findIndex(item2 => item2.icon === item.value)
      if (selectIndex !== -1) {
        this.classificationField[selectIndex].disabled = false
      }
      if (index !== -1) {
        this.dataForm.moduleList.splice(index, 1)
        this.checkedList.splice(index, 1)
      }
    },
    // 添加模块
    addModule () {
      this.dataForm.moduleList.push({
        value: '',
        value2: '',
        key: Date.now()
      })
      this.checkedList.push(
        {
          checkedList: [],
          indeterminate: false,
          checkAll: false
        }
      )
    },
    // 关闭抽屉
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 重置
    formClear () {
      this.$nextTick(() => {
        // this.classificationField.forEach(item => {
        //   item.disabled = false
        // })
        this.fixedModule.forEach(item => {
          item.chickList = []
          item.checkAll = false
          item.indeterminate = false
        })
        this.dataForm = {
          exportType: '2',
          moduleList: []
        }
        this.checkedList = []
        this.customFieldShow = true
        this.btnLoading = false
        this.searchModel = {}
      })
    }
  }
}
</script>
<style lang="less">
.closeIcon {
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .moduleColseImg {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
.allCheckBox {
  //margin-bottom: 15px;
}
.checkBoxGroupDiv {
  display: flex;
  .checkBoxGroupTitle {
    width: 60px;
  }
  .checkBoxGroup {
    width: calc(100% - 35px);
    >.ant-checkbox-group-item {
      margin-bottom: 14px;
    }
  }
}
.marginTop_10 {
  margin-top: 10px;
}
.marginBtm_0 {
  margin-bottom: 0;
}
.add-btn {
  margin-top: 20px;
}
.export_btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel {
    margin-left: 20px;
  }
}
.ant-select-dropdown{
  .ant-select-dropdown-content {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item-disabled {
        color: rgba(0, 0, 0, 0.25) !important;
      }
    }
  }
}
</style>
